import React from 'react';
import { Select, Skeleton } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setLtrFilter } from '../../../redux/store/genericReportingSlice';

const FilterDropdown = () => {
    const ltrFilter = useSelector(
        (state) => state.genericReporting.ltr_filter
    );
    const dispatch = useDispatch();

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
        }}>
        <Skeleton style={{
            'width': '10vw',
            marginLeft: '0.5vw',
            marginRight: '0.5vw',
        }} active loading={false} title={false} paragraph={{ rows: 1 }}>
            <h4>Filter</h4>
            <Select
                style={{
                    width: "10vw",
                    marginLeft: '0.5vw',
                    marginRight: '0.5vw',
                }}
                options={[
                    { label: "All", value: "All" },
                    { label: "OTP", value: "OTP" },
                    { label: "Subscription", value: "Subscription" },
                ]}
                onChange={(value) => {
                    console.log(value);
                    dispatch(setLtrFilter(value));
                }}
                value={ltrFilter}
            />
        </Skeleton>
        </div>
    );
};

export default FilterDropdown;